import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Select, Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, Menu, MenuItem, IconButton, ListItemIcon, ListItemText} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Stop from '@material-ui/icons/Stop';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import WifiTethering from '@material-ui/icons/WifiTethering';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { getObjectByID, sortByName } from '../../../api/helpers';


class LocalGroupsList_ extends React.Component{
    
    constructor(props){
        super(props)

        this.state = {
            //licenses: this.props.licenses,
            menuAnchor: null, 
            menuItem: '',
            selected: '',

            localGroups: this.getLocalGroups(),
            networks: this.getNetworks()
        }

        this.handleLocalNetworkSelect = this.handleLocalNetworkSelect.bind(this)
        this.handleLocalGroupSelect = this.handleLocalGroupSelect.bind(this)

        this.handleAddItem = this.handleAddItem.bind(this)

    }

    getRowStyle(id){
        //let selected = id === this.state.selected
        //console.log('ServerGroupMapList_.getRowStyle '+id + ' =? '+ this.state.selected)
        let selected = id === this.state.selected
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleItemSelect(id){

        let localGroup = null
        if(id!==null){
            localGroup = this.state.localGroups[id]
        }
        this.setState({selected: id})

        this.props.onAction({type: 'LOCAL_GROUP_SELECT', localGroup: localGroup})

        //this.props.onAction({type: 'SELECT_CURRENT_SERVER', externalServerID: id})
    }


    getGroups(networkID){

        //console.log('getGroups '+networkID)
        //console.log(this.state.networks)

        /*
        this.state.serverSettings.LinkedServers.forEach(linkedServer=>{
            linkedServer.LocalServerObjects.Networks.forEach(net=>{
                net.Groups.forEach
            })
        })
        */

        let network = getObjectByID(networkID, this.state.networks)

        if(network) {
            //console.log('return groups')
            //console.log(network.groups)
            return network.groups
        }
        return []
    }

    getNetworks(){

        let networks = []
        const seenNetwork = new Set()
        const seenGroup = new Set()

        this.props.serverSettings.LinkedServers.forEach(linkedServer=>{

            linkedServer.LocalServerObjects.Networks.forEach(net => {
                    
                net.Groups.forEach(group => {

                    let networkID = net.ID

                    let network
                    if(!seenNetwork.has(net.ID)){
                        
                        network = {
                            ID: net.ID,
                            name: net.Name,
                            groups: []
                        }

                        networks.push(network)

                        seenNetwork.add(net.ID)

                    }else{

                        network = getObjectByID(net.ID, networks)

                    }

                    let groupKey = group.ID + '_' + net.ID

                    if(!seenGroup.has(groupKey)){

                        let newGroup = {
                            ID: group.ID,
                            name: group.Name,
                            networkID: net.ID
                        }

                        network.groups.push(newGroup)

                        seenGroup.add(groupKey)

                    }

                })

            })

        })

        return networks
    }

    getLocalGroups(){

        let groups = []
        const seen = new Set()

        this.props.serverSettings.LinkedServers.forEach(linkedServer=>{

            linkedServer.GroupMap.forEach(groupMap => {

                let key = groupMap.LocalGroupId + '_' + groupMap.LocalNetworkId

                if (!seen.has(key)){

                    seen.add(key)

                    groups.push({
                        groupID: groupMap.LocalGroupId, 
                        networkID: groupMap.LocalNetworkId
                    })
                }

            })

        })

        return groups
    }

    handleLocalNetworkSelect(event, mapIndex){
        //console.log('handleLocalNetworkSelect')
        //console.log(event)

        this.props.onAction({type:'SET_LOCAL_NETWORK_ID', index: mapIndex, value: event.target.value} )
    }

    handleLocalGroupSelect(event, mapIndex){
        //console.log('handleLocalGroupSelect')
        //console.log(event)

        this.props.onAction({type:'SET_LOCAL_GROUP_ID', index: mapIndex, value: event.target.value} )

    }

    handleAddItem(menu){

        let localGroups = this.state.localGroups

        localGroups.push({
            groupID: '', 
            networkID: ''
        })

        this.setState({localGroups: localGroups})

    }

    handleDeleteItem(index){

        let group = this.state.localGroups[index]

        this.props.onAction({
            type: 'LOCAL_GROUP_DELETE', 
            groupID: group.groupID,
            networkID: group.networkID
        })

        this.handleItemSelect(null)
        //alert('delete '+index)
    }

    getNetworkName(networkID){
        let network = getObjectByID(networkID, this.state.networks)
        return network ? network.name : ''
    }

    getGroupName(groupID, networkID){
        let groups = this.getGroups(networkID)
        let group = getObjectByID(groupID, groups)
        return group ? group.name : ''
    }
    


    render(){
        const {t} = this.props

        //console.log('render Server Links List')
        //console.log(this.props)

        //this.state.licenses.sort(sortByName)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        };

        let localGroups = this.getLocalGroups()

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={1} style={styles.head}>{t('LocalNetwork')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('LocalGroup')}</TableCell>
                                {/*
                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        //disabled={!this.props.currentServer}
                                        onClick={this.handleAddItem}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                                */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {this.state.localGroups.map((localGroup, index) => 
                            <TableRow key={index+' '+localGroup.groupId+'_'+localGroup.networkID} 
                                    onClick={()=>{this.handleItemSelect(index)}}
                                    style={this.getRowStyle(index)}>

                                <TableCell component="th" scope="row">
                                    {this.getNetworkName(localGroup.networkID)}

                                    {/*
                                    <SelectNetwork 
                                        name='networkId'
                                        //mapIndex={index}
                                        networkID={localGroup.networkID}
                                        //currentServer={this.props.currentServer}
                                        networks={this.state.networks}
                                        onSelect={this.handleLocalNetworkSelect}  
                                    />
                                    */}
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {this.getGroupName(localGroup.groupID, localGroup.networkID)}
                                    {/** 
                                    <SelectGroup 
                                        name='groupId'
                                        //mapIndex={index}
                                        networkID={localGroup.networkID}
                                        currentServer={this.props.currentServer}
                                        groupID={localGroup.groupID}
                                        groups={this.getGroups(localGroup.networkID)}
                                        onSelect={this.handleLocalGroupSelect}
                                    />
                                    */}
                                </TableCell>

                                {/*
                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="more" component="span"
                                        //disabled={!this.props.currentServer}
                                        onClick={event=>{this.handleDeleteItem(index); event.stopPropagation();}}>
                                        <DeleteForeverIcon/>
                                    </IconButton>
                                </TableCell>
                                */}
                                
                            </TableRow>
                        )}
                        </TableBody>

                    </Table>    
                </Paper>
            </>
        )

    }

}

class SelectNetwork extends React.Component{

    checkError(){

        if(!this.props.networkID){
            return(true)
        }

        if(this.props.networkID){
            let exists = false
            this.props.networks.forEach(net => {
                if(net.ID===this.props.networkID){
                    exists = true
                }
            })

            if(!exists) return true

        }

        return false
    }


    render(){

        //console.log('render SelectNetwork '+ this.props.mapIndex)
        //console.log(this.props.networks)
        //console.log(this.props.currentServer)

        let error = this.checkError()
        //console.log(error)

        return(
            <Select 
                style={{minWidth: 180}}
                error={error}
                value={this.props.networkID?this.props.networkID:''}
                onChange={event=>{
                    this.props.onSelect(event, this.props.mapIndex)
                }}
                inputProps={{
                    name: this.props.name,
                    id: this.props.name,
                }}
                >

                {this.props.networks.map(net => (
                    <MenuItem key={net.ID} value={net.ID}>{net.name}</MenuItem>
                ))}
            </Select>
        )

    }

}

class SelectGroup extends React.Component{


    checkError(){

        if(!this.props.groupID){
            return(true)
        }

        if(this.props.groupID){
            let exists = false
            this.props.groups.forEach(group => {
                if(group.ID===this.props.groupID){
                    exists = true
                }
            })

            if(!exists) return true

        }

        return false
    }



    render(){

        //console.log('render SelectGroup '+ this.props.mapIndex)
        //console.log(this.props.groups)
        //console.log(this.props.currentServer)

        let error = this.checkError()
        ///console.log(error)

        return(
            <Select 
                style={{minWidth: 180}}
                error={error}
                value={this.props.groupID?this.props.groupID:''}
                onChange={event=>{
                    this.props.onSelect(event, this.props.mapIndex)
                }}
                inputProps={{
                    name: this.props.name,
                    id: this.props.name,
                }}
                >

                {this.props.groups.map(group => (
                    <MenuItem key={this.props.networkID+'_'+group.ID} value={group.ID}>{group.name}</MenuItem>
                ))}
            </Select>
        )

    }

}

export const LocalGroupsList = withTranslation()(LocalGroupsList_);